import type { Block } from '@/types/blocks';

export function blockAnchorId(block: Pick<Block, 'internalName'>): string | undefined {
  const value = block.internalName
    ?.trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return value || undefined;
}
